<template>
  <div class="main main--hasHeader main--hasFooter">
    <div class="customContainer">
      <div class=" mb-2" v-if="member_code_sw">
          <card-view @to_click_event="member_code_switch_action" :memberData="getMyData" :codeSw="true" :btnView="false"></card-view>
      </div>
      <div v-else class="row mb-5" >
          <div class="col text-center">
              <button @click="member_code_switch_action('open')" class="badge bg-dark">会員証を表示</button>
          </div>
      </div>
      <div v-if="checkinData != false">
        <router-link class="members__headline-btn" to="/user/checkin">{{ word_chg('チェックイン情報') }}</router-link>
      </div>
      <div class="members-menu">
        <div class="members-menu__card">
          <ul class="row members-menu__articles">
            <li class="col-4 members-menu__article">
              <router-link to="/user/detail">
                <span class="icon">
                  <img src="@/assets/img/main/members_menu_img_01.png" alt="">
                </span>
                <span class="text">{{ word_chg('会員情報') }}</span>
              </router-link>
            </li>
            <li class="col-4 members-menu__article">
              <router-link to="/user/car">
                <span class="icon">
                  <img src="@/assets/img/main/members_menu_img_06.png" alt="">
                </span>
                <span class="text">{{ word_chg('車両情報') }}</span>
              </router-link>
            </li>
            <li class="col-4 members-menu__article">
              <router-link to="/user/guest">
                <span class="icon">
                  <img src="@/assets/img/main/members_menu_img_02.png" alt="">
                </span>
                <span class="text">{{ word_chg('ゲスト情報') }}</span>
              </router-link>
            </li>
            <li class=" offset-2 col-4 members-menu__article d-none">
              <router-link to="/user/friend">
                <span class="icon">
                  <img src="@/assets/img/main/members_menu_img_03.png" alt="">
                </span>
                <span class="text">{{ word_chg('フレンド情報') }}</span>
              </router-link>
            </li>
            <li class="offset-4 col-4 members-menu__article">
              <router-link to="/history/drive">
                <span class="icon">
                  <img src="@/assets/img/main/members_menu_img_04.png" alt="">
                </span>
                <span class="text">{{ word_chg('走行履歴') }}</span>
              </router-link>
            </li>
            <li class="col-4 members-menu__article">
              <!-- <router-link to="/reserved/drive">
                <span class="icon">
                  <img src="@/assets/img/main/members_menu_img_05.png" alt="">
                </span>
                <span class="text">走行予約</span>
              </router-link> -->
            </li>
            <!-- <li class="col-4 members-menu__article">
              <p class="disabled"><span class="icon"><img src="@/assets/img/main/members_menu_img_03.png" alt=""></span><span class="text">チェックイン</span></p>
            </li> -->
          </ul>
        </div>
        <div class="members-menu__list">
          <ul>
            <!-- <li >
              <a :href="'https://www1.ms-event.net/mgcweb/mgwfile/membership_rules_regular_' + app_lang_type + '.24.01.18.pdf'" target="_blank">
                {{ word_chg('正会員規約') }}
              </a>
            </li>
            <li >
              <a :href="'https://www1.ms-event.net/mgcweb/mgwfile/membership_rules_associate_' + app_lang_type + '.24.01.18.pdf'" target="_blank">
                {{ word_chg('アソシエイト会員規約') }}
              </a>
            </li> -->
                    <!-- <li v-if="app_lang_type=='en'">
                        <a href="https://www1.ms-event.net/mgcweb/mgwfile/drive_rule_regulations_en.24.01.03.pdf" target="_blank">
                            {{ word_chg('走行規約タイトル') }}
                        </a>
                    </li>
                    <li v-else-if="app_lang_type=='ja'">
                        <a href="https://www1.ms-event.net/mgcweb/mgwfile/drive_rule_regulations_ja.24.01.03.pdf" target="_blank">
                            {{ word_chg('走行規約タイトル') }}
                        </a>
                    </li> -->
                    <!-- <li v-if="app_lang_type=='ja'">
                        <a href="https://www1.ms-event.net/mgcweb/mgwfile/members_guide_ja.23.10.26.pdf" target="_blank">
                            {{ word_chg('メンバーズガイド') }}
                        </a>
                    </li>
                    <li v-else-if="app_lang_type=='en'">
                        <a href="https://www1.ms-event.net/mgcweb/mgwfile/members_guide_en.23.10.26.pdf" target="_blank">
                            {{ word_chg('メンバーズガイド') }}
                        </a>
                    </li>

                    <li v-if="app_lang_type=='ja'">
                        <a href="https://www1.ms-event.net/mgcweb/mgwfile/facility_guide_ja.23.10.26.pdf" target="_blank">
                            {{ word_chg('ファシリティガイド') }}
                        </a>
                    </li>
                    <li v-else-if="app_lang_type=='en'">
                        <a href="https://www1.ms-event.net/mgcweb/mgwfile/facility_guide_en.23.10.26.pdf" target="_blank">
                            {{ word_chg('ファシリティガイド') }}
                        </a>
                    </li> -->
            <li>
              <router-link to="/user/access">
                {{ word_chg('アクセス') }}
              </router-link>
            </li>
            <li>
              <router-link to="/inquiry/index">
                {{ word_chg('お問い合わせ') }}
              </router-link>
            </li>
            <!-- <li>
              <router-link to="/user/policy">
                {{ word_chg('プライバシーポリシー') }}
              </router-link>
            </li> -->
          </ul>
        </div>
      </div>
    </div>
  </div>

</template>
<script>
// import { mapState } from 'vuex'
// import BsPageTitle from '../../molecules/BsPageTitle.vue'
import CardView from './CardView.vue'

import config from '../../../const'
// import axios from 'axios'
import { mapState } from 'vuex'
// import Common from '../../common/common'

export default {
  name: 'UserIndexVIew',
  data: function () {
      return {
        member_code_sw: true,
      }
  },
  components: {
      // BsPageTitle,
        CardView,
    //   BsSelect,
      // BsCheckBox,
  },
  methods: {
    // login御
    loadUser(){
      const params = {};
      params['id'] = this.$store.state.auth.userId;
      console.log('params', params);
      return this.$store.dispatch('fetchBasicLists', {data: params, target: 'user', targetF: 'get'})
      .catch((err) => {
        console.log(err);
        Promise.reject(err)
      })
      .then(() => {})
      .finally(() => {});
    },
    member_code_switch_action(sw){
        if(sw == 'open'){
            this.member_code_sw = true;
        }else{
            this.member_code_sw = false;
        }
    },
  },
  computed: {
    ...mapState({
      user: state => state.apidata.user,
      set_lang: state => state.apidata.set_lang,
    }),
    app_lang_type: function (){
            // console.log('com')
            if(this.set_lang){
                return this.set_lang;
            }
            else{
                return this.$store.state.auth.app_lang_type;
            }
    },
    membership_type: function(){
      return this.getMyData.kbn_label;
    },
    getMyData: function(){
      const mydata = this.user.find((data) => {
        return data.id == this.$store.state.auth.userId;
      })
      return mydata;
    },
    checkinData: function(){
      if(
        typeof this.getMyData === 'object' && typeof this.getMyData.checkin === 'object'
      ){
        return this.getMyData.checkin;
      }
      else{
        return false;
      }
    },
    axiosHeader: function(){
        return {[config.BASE_API_HEADER_KEY]: this.$store.state.auth.token};
    },
    // customer: state => state.apidata.customer,
  },
  created () {
    this.loadUser();
  },
  mounted: function(){
    console.log('check page mounted!!!', this.getMyData);
    if(this.getMyData === undefined || this.getMyData === 'undefined' || this.getMyData === 'false' || this.getMyData === false){
      console.log('check page getMyData!!! logout');
      this.$router.push({ path: '/logout' });
    }
  },
  props: {
  }
}
</script>
